import { render, staticRenderFns } from "./Bloqueio.vue?vue&type=template&id=70280ba4&"
import script from "./Bloqueio.vue?vue&type=script&lang=js&"
export * from "./Bloqueio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports